<template>
  <div>
    <div class="h-panel">
      <b-button v-b-modal.help-modal>Help</b-button>

      <b-button
        v-if="mayAddMassPending"
        :to="{name: 'players_pending_add'}"
        variant="primary"
      >
        New mass pending
      </b-button>

      <b-button
        v-if="mayAddMassPending"
        :to="{name: 'players_pending_add_follow_link'}"
        variant="primary"
      >
        New mass pending link
      </b-button>

      <b-button class="mt-1"
        v-if="mayAddMassPending"
        :to="{name: 'players_pending_add_for_vip'}"
        variant="primary"
      >
        New mass pending VIP
      </b-button>

    </div>

    <h2>Mass pendings</h2>

    <p v-if="message !== null">
      {{message}}
    </p>

    <table v-if="massPendings !== null && massPendings.length > 0" class="table table-bordered text-nowrap">
      <thead class="thead-dark">
        <tr>
          <th rowspan="2" scope="col">Id</th>
          <th rowspan="2" scope="col">Time</th>
          <th rowspan="2" scope="col">Players<br>amount</th>
          <th colspan="2" scope="col" class="text-center">Product</th>
        </tr>
        <tr>
          <th scope="col">Type</th>
          <th scope="col" class="text-right">Amount</th>
        </tr>
      </thead>
      <tr
        v-for="massPending in massPendings"
        :key="massPending.id"
      >
        <td>
          <mass-pending-link
            :massPendingId="massPending.id"
            lable=""
          />
        </td>
        <td>
          {{massPending.ctime | getMomentStr}}
        </td>
        <td class="text-right">
          <router-link
            :to="{name: 'mass_pending_players', params: {massPendingId: massPending.id}}"
          >
            {{massPending.playersAmount | getFormattedNumber}}
          </router-link>
        </td>
        <td>
          {{massPending.productId | getProtoAlias}}
        </td>
        <td class="text-right">
          {{massPending.amount | getFormattedNumber}}
        </td>
      </tr>
    </table>

    <loading-indicator
      v-if="isLoading"
    />

    <b-modal id="help-modal" title="Help" ok-only ok-title="Close">
      <div class="help">
        <p>
          All mass pendings are shown on this page.
        </p>
      </div>
    </b-modal>

  </div>
</template>

<script>
import auth from '../auth';
import { HTTP } from '../http-common';
import notifier from '../notifier';

import { mayAddMassPending as utilMayAddMassPending } from '../util';

import LoadingIndicator from './LoadingIndicator.vue';
import MassPendingLink from './MassPendingLink.vue';

export default {
  name: 'PlayersPendings',

  components: {
    LoadingIndicator,
    MassPendingLink,
  },

  data() {
    return {
      actor: auth.getViewer(),
      isLoading: false,
      massPendings: null,
    };
  },

  computed: {
    mayAddMassPending() {
      return utilMayAddMassPending(this.actor.role);
    },

    message() {
      if(this.massPendings !== null && this.massPendings.length === 0) {
        return 'No mass pendings.';
      }
      return null;
    },
  },

  created() {
    this.loadMassPendings();
  },

  methods: {
    loadMassPendings() {
      this.isLoading = true;

      HTTP.get('/players/pendings')
      .then(response => {
        this.isLoading = false;

        const data = response.data.data;
        if(data === null) {
          notifier.showError('Invalid server response. data === null.', {sender: this});
          return;
        }

        const massPendings = data;
        massPendings.sort((a, b) => b.id - a.id);

        this.massPendings = massPendings;
      })
      .catch(e => {
        this.isLoading = false;
        notifier.showError(e.response.data);
      });
    },
  },
}
</script>
